import Table2 from "../../../../../components/Table2";
import { useMonitoreoPersonalStore } from "../../../../../store/monitoreoPersonal";
import { tableData } from "./tableData";


const TablaInteraccionesUnDia = () => {

    const { interaccionesUnDia } = useMonitoreoPersonalStore();

    return (
        <>
            <Table2
                height={"450px"}
                data={tableData(interaccionesUnDia?.interacciones)}
            />
        </>
    );
}
export default TablaInteraccionesUnDia;